/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { useContext } from 'react';
import intCommands from './commands';
import IntegrationList from './IntegrationList';
import IntegrationContext from './IntegrationContext';

export default (): Element<string> => {
  const intCtx = useContext(IntegrationContext);

  return (
    <div data-testid="IntegrationLanding">
      <IntegrationList key={intCtx.state.navMode} />
      <div
        className="d-flex align-items-center justify-content-around"
        css={css('min-height: 30vh;')}
      >
        <a
          tabIndex={0}
          className="btn btn-lg btn-primary rounded"
          onClick={() => {
            intCommands(intCtx).startNewIntegration();
          }}
        >
          New Button
        </a>
      </div>
    </div>
  );
};
